function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Trie from '../utils/trie';
import { sendTracking } from './events';
export var SearchHistoryModule = function SearchHistoryModule(_ref) {
  var _this = this;

  var lurkerId = _ref.lurkerId,
      historyMaxWords = _ref.historyMaxWords,
      historyMaxSuggestions = _ref.historyMaxSuggestions,
      initialHistoryMaxSuggestions = _ref.initialHistoryMaxSuggestions,
      hideSuggestions = _ref.hideSuggestions,
      historyKey = _ref.historyKey;

  _defineProperty(this, "getHistoryList", function () {
    var historyList = JSON.parse(localStorage.getItem(_this.localStorageHistoryKey)) || [];
    return historyList;
  });

  _defineProperty(this, "setHistoryTrie", function () {
    var historyList = this.getHistoryList();
    var trie = new Trie(this.historyMaxWords);
    var date = new Date().getTime();

    for (var _iterator = _createForOfIteratorHelperLoose(historyList.entries()), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
          index = _step$value[0],
          word = _step$value[1];
      trie.insert(word, date + index);
    }

    return trie;
  });

  _defineProperty(this, "getHistorySuggestions", function (value) {
    var historySuggestions = [];

    if (_this.historyMaxWords > 0 && _this.historyMaxSuggestions > 0 && _this.initialHistoryMaxSuggestions > 0) {
      var suggestionsLimit = (value === null || value === void 0 ? void 0 : value.trim().length) ? _this.historyMaxSuggestions : _this.initialHistoryMaxSuggestions;
      historySuggestions = _this.historyTrie.find(value === null || value === void 0 ? void 0 : value.toLowerCase()).slice(0, suggestionsLimit).map(function (h) {
        return {
          query: h
        };
      });
    }

    _this.historySuggestions = historySuggestions;
    return historySuggestions;
  });

  _defineProperty(this, "addHistoryItem", function (word) {
    word = word.trim().toLowerCase();

    _this.historyTrie.insert(word);

    var historyList = _this.historyTrie.allWords();

    localStorage.setItem(_this.localStorageHistoryKey, JSON.stringify(historyList));
  });

  _defineProperty(this, "updateSuggestionsList", function (word) {
    var historySuggestions = [].concat(_this.historySuggestions);
    var index = historySuggestions.findIndex(function (s) {
      return s.query === word;
    });
    historySuggestions.splice(index, 1);
    _this.historySuggestions = historySuggestions;
  });

  _defineProperty(this, "deleteHistoryItem", function (event, word, query, lurkerObjectName) {
    event.preventDefault();

    _this.historyTrie.remove(word);

    var historyList = _this.historyTrie.allWords();

    localStorage.setItem(_this.localStorageHistoryKey, JSON.stringify(historyList));

    _this.updateSuggestionsList(word);

    var trackingPayload = {
      event_type: 'click',
      object_detail: 'delete_history',
      object_name: lurkerObjectName,
      data: {
        typed_query: query,
        query: word
      }
    };
    sendTracking(trackingPayload);
  });

  this.lurkerId = lurkerId;
  this.historyMaxWords = hideSuggestions ? 0 : historyMaxWords;
  this.historyMaxSuggestions = hideSuggestions ? 0 : historyMaxSuggestions;
  this.initialHistoryMaxSuggestions = hideSuggestions ? 0 : initialHistoryMaxSuggestions;
  var historyKeyPrefix = historyKey || 'search-history';
  this.localStorageHistoryKey = historyKeyPrefix + "_" + lurkerId;
  this.historyTrie = this.setHistoryTrie();
  this.historySuggestions = [];
} // onHistorySuggestionSelected = (
//   event,
//   { suggestion, suggestionIndex, submitMethod }
// ) => {
//   event.persist()
//   // this.setState({
//   //   value: suggestion,
//   //   query: suggestion
//   // }, () => {
//   // const data = {
//   //   query: suggestion,
//   //   typed_query: suggestion,
//   //   method: submitMethod,
//   //   current_category_id: this.getCurrentCategory(),
//   //   history_position: suggestionIndex,
//   //   history_list: this.formatHistorySuggestionsListTracking()
//   // }
//   // const trackingPayload = {
//   //   event_type: 'click',
//   //   object_detail: 'history_search',
//   //   object_name: this.state.lurkerObjectName,
//   //   data
//   // }
//   // this.addHistoryItem(suggestion)
//   // this.sendTracking(trackingPayload)
//   // })
//   // this.hideSuggestions()
//   this.addHistoryItem(suggestion)
// }
;